/* ─────────────────────────────────────────────────────────────
   ELO CONFIG — Single source of truth for all ELO algorithm
   constants. Import from here whenever ELO logic is written
   so we never hardcode these values in multiple places.
   ───────────────────────────────────────────────────────────── */

export const eloConfig = {
  // Every new player starts at this rating
  startingRating: 1200,

  // Ratings never fall below this floor
  minimumRating: 100,

  // Smooth decay K-factor: K = floor(kBase + (kDecay / (1 + n / kDecayRate)))
  // New players start near K=64 for fast placement, asymptotically
  // approaching K=32 as match count grows. No hard thresholds.
  //
  // Example values:
  //   n=0  → K=64   n=15 → K=48   n=30 → K=42   n=100 → K=36   n=∞ → K=32
  kBase:      32,   // floor K approaches as matches → ∞
  kDecay:     32,   // extra K added for new players
  kDecayRate: 15,   // controls how fast K decays (higher = slower)

  // Margin of victory multipliers — applied to the K-factor to
  // reward dominant wins and soften the impact of narrow ones.
  // Keyed as "format_winnerGames_loserGames".
  // bo1 has no margin concept so it always uses 1.00.
  marginMultipliers: {
    bo1:        { default: 1.00 },
    bo3_2_0:    1.25,   // 2–0: dominant
    bo3_2_1:    0.80,   // 2–1: narrow
    bo5_3_0:    1.25,   // 3–0: dominant
    bo5_3_1:    1.00,   // 3–1: clear
    bo5_3_2:    0.80,   // 3–2: narrow
    bo7_4_0:    1.25,   // 4–0: dominant
    bo7_4_1:    1.10,   // 4–1: clear
    bo7_4_2:    1.00,   // 4–2: moderate
    bo7_4_3:    0.80,   // 4–3: narrow
  },
};
